/**
 * « Nouveau geste » : l'écriture touchée demande un geste qu'on n'a pas encore pris dans la trousse. La main
 * montre la trousse (fermée), puis la carte du geste (trousse ouverte) — comme dans la démo guidée, sans le
 * reste du coach. On l'explique (le panneau du Move), puis on s'en sert.
 */
import { useEffect, useState } from 'react';
import { CoachHand } from '@/features/scratch-tutorial/coach-hand';
import './move-panel.css';
import type { MoveDef } from './move-catalog';

/** Ce qu'on montre du doigt : la trousse fermée, sinon la carte du geste. PUR. */
export function nudgeSelector(move: MoveDef, kitOpen: boolean): string {
  return kitOpen ? `[data-item="move-${move.id}"]` : '[data-testid="trousse"]';
}

export function MoveNudge({
  move,
  kitOpen: given,
  hand = true,
}: {
  move: MoveDef;
  /** la trousse est ouverte ; absent : lu sur la trousse elle-même (`aria-expanded`) */
  kitOpen?: boolean;
  /** la main du coach (faux dans les tests, qui n'ont pas de boucle d'images) */
  hand?: boolean;
}) {
  const [seenOpen, setSeenOpen] = useState(false);
  const kitOpen = given ?? seenOpen;
  const selector = nudgeSelector(move, kitOpen);
  useEffect(() => {
    // l'élément peut arriver après nous (trousse qui s'ouvre) : on le cherche à intervalle court
    let el: HTMLElement | null = null;
    const find = () => {
      if (given === undefined)
        setSeenOpen(
          document.querySelector('[data-testid="trousse"]')?.getAttribute('aria-expanded') ===
            'true',
        );
      const next = document.querySelector<HTMLElement>(selector);
      if (next === el) return;
      el?.removeAttribute('data-coach-target');
      el = next;
      el?.setAttribute('data-coach-target', '');
    };
    find();
    const t = window.setInterval(find, 250);
    return () => {
      window.clearInterval(t);
      el?.removeAttribute('data-coach-target');
    };
  }, [selector, given]);

  return (
    <>
      <p className="jr-move-nudge" role="status" data-testid="move-nudge" data-move={move.id}>
        <span aria-hidden>↹</span>
        <span>
          <b>Nouveau geste : {move.name}.</b>{' '}
          {kitOpen ? 'Touche sa carte pour l’apprendre.' : 'Prends-le dans ta trousse.'}
        </span>
      </p>
      {hand && <CoachHand />}
    </>
  );
}
